import { render, staticRenderFns } from "./wave3d2.vue?vue&type=template&id=58e44146&scoped=true"
import script from "./wave3d2.vue?vue&type=script&lang=js"
export * from "./wave3d2.vue?vue&type=script&lang=js"
import style0 from "./wave3d2.vue?vue&type=style&index=0&id=58e44146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e44146",
  null
  
)

export default component.exports